import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useQuery } from 'urql';
import Customer from '@outdoor-voices/ui/dist/utils/Customer';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/browser';
import { COMPONENTS } from './componentLibrary';
import { HOMEPAGE_QUERY, HOMEPAGES_QUERY } from './queries';
import css from './Homepage.module.scss';
import ErrorBoundary from '../../components/ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var getComponents = function getComponents(_ref) {
  var homepages = _ref.homepages,
      homepage = _ref.homepage;

  if (homepage) {
    return homepage.components.edges;
  }

  var edges = homepages.edges;
  var node = edges[0].node;
  return node.components.edges;
};

var Homepage = function Homepage(_ref2) {
  var loadingHTML = _ref2.loadingHTML,
      query = _ref2.query,
      variables = _ref2.variables;

  var _useQuery = useQuery({
    query: query,
    variables: variables
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      error = _useQuery2$.error,
      fetching = _useQuery2$.fetching,
      data = _useQuery2$.data;

  if (fetching) {
    return /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: loadingHTML
      }
    });
  }

  if (error) {
    var graphQLErrors = error.graphQLErrors,
        networkError = error.networkError;
    console.error(networkError, graphQLErrors);

    if (Sentry) {
      Sentry.captureException(error);
    }

    return /*#__PURE__*/_jsxs("div", {
      className: css.errorRoot,
      "data-testid": "error",
      children: [/*#__PURE__*/_jsx("h2", {
        children: "Oops...Something went wrong."
      }), /*#__PURE__*/_jsx("p", {
        className: css.details,
        children: error.message
      })]
    });
  }

  var components = getComponents(data);
  return /*#__PURE__*/_jsx("ul", {
    className: css.list,
    children: components.length > 0 && components.map(function (_ref3, idx) {
      var component = _ref3.node;
      var componentType = component.componentType,
          id = component.id;
      var Component = COMPONENTS[componentType];
      return Component && /*#__PURE__*/_jsx("li", {
        className: css.listItem,
        id: id,
        children: /*#__PURE__*/_jsx(ErrorBoundary, {
          children: /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, component), {}, {
            lazyload: idx !== 0
          }))
        })
      }, id);
    })
  });
};

Homepage.propTypes = {
  loadingHTML: PropTypes.string,
  query: PropTypes.string.isRequired,
  variables: PropTypes.shape().isRequired
};

var GetHomepageProps = function GetHomepageProps(_ref4) {
  var loadingHTML = _ref4.loadingHTML;
  var customer = new Customer();
  var search = window.location.search;
  var segment = customer.getSegment();
  var previewId = search.match(/preview=(\d+)/);
  var isPreview = previewId && previewId[1];
  var homepageId = isPreview ? btoa("HomepageNode:".concat(previewId[1])) : null;
  var query = isPreview ? HOMEPAGE_QUERY : HOMEPAGES_QUERY;
  var variables = isPreview ? {
    id: homepageId
  } : {
    segment: segment,
    status: 'PUBLISHED'
  };
  return /*#__PURE__*/_jsx(Homepage, {
    loadingHTML: loadingHTML,
    variables: variables,
    query: query
  });
};

GetHomepageProps.propTypes = {
  loadingHTML: PropTypes.string
};
export default GetHomepageProps;